// ---------------------------------------------------------------------------
// staff dashboard access (ui)
// ---------------------------------------------------------------------------

const PROPERTIES_TAB_ONLY_EMAILS = new Set<string>([
  "jerome@blirumahproperty.com",
]);

/** staff signed in with this email only see the properties sidebar tab */
export function isPropertiesTabOnlyEmail(email: string | undefined): boolean {
  if (!email) {
    return false;
  }
  return PROPERTIES_TAB_ONLY_EMAILS.has(email);
}
